<template>
  <div class="war-room-post-content-linkedin">
    <div class="war-room-post-content-linkedin__info">
      <img :src="content.linkedin_avatar_url" alt="" class="war-room-post-content-linkedin__avatar" />
      <div class="war-room-post-content-linkedin__name">{{ content.linkedin_name }}</div>
      <div class="war-room-post-content-linkedin__posted">
        posted on
        <a
          :href="content.link_url"
          class="war-room-post-content-linkedin__link"
          target="_blank"
          rel="nofollow noopener noreferrer"
        >
          LinkedIn
        </a>
      </div>
      <LinkedinIcon width="24" height="24" class="war-room-post-content-linkedin__icon" />
    </div>
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div class="war-room-post-content-linkedin__text" v-html="content.linkedin_text" />
    <NuxtImg
      v-for="image in content.linkedin_attached_images"
      :key="image.id"
      :width="IMAGE_SIZE"
      :height="IMAGE_SIZE"
      :src="image.url"
      alt=""
      class="war-room-post-content-linkedin__image"
    />
  </div>
</template>

<script lang="ts" setup>
import LinkedinIcon from '@/assets/svg/linkedin.vue.svg';
import type { IPostContentDataLinkedin } from '@/types/community';

type WarRoomPostContentLinkedinProps = {
  content: IPostContentDataLinkedin;
};

defineProps<WarRoomPostContentLinkedinProps>();

const IMAGE_SIZE = 64;
</script>

<style scoped lang="scss">
.war-room-post-content-linkedin {
  padding: 16px 16px 24px;
  background: var(--theme-color-over-card);
  border-radius: 8px;

  &__info {
    display: flex;
    align-items: center;
  }

  &__avatar {
    min-width: 0;
    min-height: 0;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    object-fit: contain;
    margin-right: 10px;
    flex-shrink: 0;
    background: var(--gray-10);
  }

  &__name {
    @include subhead-semibold;

    color: var(--theme-color-text);
  }

  &__posted {
    position: relative;
    margin-right: 6px;
    margin-left: 6px;
    padding-left: 6px;
    font-size: 13px;
    line-height: 1.38;
    color: var(--theme-color-sub-text);

    &::before {
      content: '';
      position: absolute;
      width: 2px;
      height: 2px;
      border-radius: 50%;
      background: var(--theme-color-sub-text);
      left: 0;
      top: 50%;
      margin-top: -1px;
    }
  }

  &__link {
    @include inherit-font;
  }

  &__text {
    @include body;

    margin-top: 16px;
    color: var(--theme-color-text);

    ::v-deep * {
      @include inherit-font;
    }
  }

  &__icon {
    flex-shrink: 0;
    color: #0077b5;
    margin-left: auto;
  }

  &__image {
    margin-top: 6px;
    max-width: 100%;
  }
}
</style>
